import styled from 'styled-components';

const BuilderItem = styled.div`
  border: 2px solid #efefef;
  position: relative;
  margin-bottom: 20px;
  padding: 20px;
`;
export const RemoveBuilderItem = styled.div`
  position: absolute;
  right: 15px;
  bottom: 15px;
  z-index: 10;
  cursor: pointer;
  width: 40px;
  height: 40px;
`;

export const MoveBuilderItem = styled.div`
  position: absolute;
  right: ${props => (props.up ? '60px' : '100px')};
  bottom: 15px;
  z-index: 10;
  cursor: pointer;
  width: 40px;
  height: 40px;
`;

export default BuilderItem;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/Content/BuilderItem.js